var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.amt != 0)?_c('div',[_c('span',{staticClass:"C1"},[_vm._v(_vm._s(_vm.amt))]),_vm._v(" 元 ")]):_c('div',[(_vm.sGetConfig('chkCarHide0Price'))?_c('div'):_c('div',[_c('span',{staticClass:"C1"},[_vm._v(_vm._s(_vm.amt))]),_vm._v(" 元 ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }